var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "41px",
    viewBox: "0 0 44 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "f-comment") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uq-news-single",
    transform: "translate(-265.000000, -1478.000000)",
    stroke: "#888888",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "coment-head",
    transform: "translate(267.000000, 1480.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f-comment"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.3333333,26.5333333 C38.2666667,23.6666667 40,20 40,16 C40,6.93333333 31.0666667,0 20,0 C8.93333333,0 0,6.93333333 0,16 C0,25.0666667 8.93333333,32.3333333 20,32.3333333 C21.9333333,32.3333333 23.8,32.0666667 25.6,31.6666667 L36,36 L35.3333333,26.5333333 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 11.5,
    x2: 29,
    y2: 11.5,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 19.5,
    x2: 21,
    y2: 19.5,
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentIcon);
export default __webpack_public_path__ + "static/media/comment-icon.b1ca8ae40c2a99183de4ee3b1718872a.svg";
export { ForwardRef as ReactComponent };